import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';

export interface EmspBoLocationCityFilterStateControllerProps {
  value: string;
  onRemove: FilteredItemProps['onRemove'];
}

export const EmspBoLocationCityFilterStateController = ({
  value,
  onRemove,
}: EmspBoLocationCityFilterStateControllerProps): React.JSX.Element => (
  <FilteredItem icon="location" label={value} onRemove={onRemove} />
);
